import { useCallback, useRef } from 'react';

/* A volta do foco para quem abriu o diálogo (README do DS, seção 12).
 *
 * O Dialog do Radix só devolve o foco a um `DialogTrigger`. Os diálogos abertos
 * por estado ou por evento (o histórico pelo widget de créditos, o modal de
 * créditos pelo 402) não têm trigger, e o foco caía no <body>. Este gancho guarda
 * o elemento focado no instante em que o diálogo abre (antes de o Radix mover o
 * foco para dentro) e volta para ele ao fechar, se ele ainda estiver na página. */
export function useVoltaDoFoco() {
  const origem = useRef(null);
  const onOpenAutoFocus = useCallback(() => {
    origem.current = document.activeElement;
  }, []);
  const onCloseAutoFocus = useCallback((evento) => {
    const el = origem.current;
    origem.current = null;
    if (el && el !== document.body && document.contains(el) && typeof el.focus === 'function') {
      evento.preventDefault();
      el.focus();
    }
  }, []);
  return { onOpenAutoFocus, onCloseAutoFocus };
}
